export const workExpArray = [
  {
    role: "Engineering Manager / Principal Engineer",
    company: "Autodesk",
    companylogo: require("../assets/images/autodeskLogo.png"),
    date: "Feb 2025 – Present (Oslo, Norway)",
    desc: `Leadership & Organizational Impact: Lead and mentor 6 engineers (Junior to Principal), driving technical excellence, career growth, and performance calibration. Rebuilt and scaled the technical hiring process, increasing hiring throughput from 1 hire every two months to 2 hires per month while raising technical quality standards. Introduced structured feedback and performance frameworks (Core Quadrant, Multipliers by Liza Wiseman), contributing to a 30% increase in employee satisfaction. Elevated engineering culture by strengthening technical assessment rigor and cross-team calibration practices.
Technical Leadership & Architecture: Tech Lead for Autodesk Forma Ecosystem: APIs, MCPs, Extensions, Agentic AI integrations. Architect enterprise-grade authentication and authorization systems (OAuth 2.0), ensuring scalability, reliability, and regulatory compliance. Initiated and led the MCP proof of concept for Autodesk University (AU), now in production, which resulted in the formation of a dedicated MCP squad under my leadership. Drive architectural strategy across cloud-native, serverless microservices and micro-frontend systems following the CAP theorem. Established operational excellence practices (Datadog, PagerDuty, AI-driven support tooling), improving reliability and incident response maturity.`,
    descBullets: [
      `Skills & Technologies: Engineering Management · Technical Leadership · OAuth 2.0 · MCP · Agentic AI · Forma Ecosystem · Microservices · Micro-Frontends · Datadog · PagerDuty · Cloud-Native · Serverless · Hiring & Calibration`
    ]
  },
  {
    role: "Cofounder and Chief Product & Technology Officer",
    company: "SkogApp / TAVANA",
    companylogo: require("../assets/images/skogAppLogo.png"),
    companylogos: [
      require("../assets/images/skogAppLogo.png"),
      require("../assets/images/tavanaLogo.png")
    ],
    date: "Jan 2023 – Feb 2025 (Oslo, Norway)",
    desc: `Defined product vision and technical strategy for two AI-driven ventures in forestry and healthcare. Built and led cross-functional teams to develop scalable web/mobile platforms and production ML systems.
SkogApp: Reduced forestry plan creation time from two years to 30 minutes through satellite-image ML models and geospatial analytics.
TAVANA: Built Norway's first medical-domain LLM, reducing documentation time by 30–60 minutes per doctor per day, in collaboration with Harvard Medical School and MIT.`,
    descBullets: [
      `Skills & Technologies: Leadership · Product & Tech Strategy · ML · LLM · Geospatial · Satellite Imagery · Microservices · AWS · TypeScript · React · CI/CD · Terraform · PostgreSQL/PostGIS · Firestore`
    ]
  },
  {
    role: "Entrepreneur in Residence",
    company: "Antler",
    companylogo: require("../assets/images/antlerLogo.png"),
    date: "Feb 2023 – May 2023 (Oslo, Norway)",
    desc: `Participated in a rigorous three-month startup program provided by Antler, focused on building and scaling early-stage ventures, and successfully secured pre-seed investment. Won the Google Hackathon award for building the most secure and scalable technical solution in the program.`,
    descBullets: [
      `Skills & Technologies: Startup building · Pre-seed fundraising · Technical strategy · Security · Scalability`
    ]
  },
  {
    role: "Head of Engineering",
    company: "Spark Sport NZ",
    companylogo: require("../assets/images/sparksportLogo.png"),
    date: "Feb 2022 – Jun 2023 (Auckland, New Zealand)",
    desc: `Led and mentored a 15-person engineering organization, defining architecture strategy and delivery standards for a multi-platform sports streaming ecosystem serving up to 1M users. Implemented CI/CD and automated testing, enhancing product quality and reducing deployment time and cloud-computing costs by 30%. Fostered a collaborative team environment, improving team satisfaction and retention rates.`,
    descBullets: [
      `Skills & Technologies: Leadership · Enterprise Architecture · TypeScript · Node.js · React · CI/CD · Snowflake · PagerDuty · DataDog · AI-based anomaly detection · Multi-platform streaming`
    ]
  },
  {
    role: "Solution Architect / Tech Lead (Contractor)",
    company: "Mercury NZ Ltd.",
    companylogo: require("../assets/images/mercuryLogo.png"),
    date: "Jul 2021 – Feb 2022 (Auckland, New Zealand)",
    desc: `Led the modernization of a legacy system by designing a microservice architecture and implementing scalable, secure RESTful APIs using serverless technologies, resulting in a 40% cost reduction. Saved the company a potential $2 million loss by identifying the compatibility issue of the new energy platform (Bidgely) with the current tech stack.`,
    descBullets: [
      `Skills & Technologies: Solution Architecture · Microservices · RESTful APIs · Serverless · TypeScript · React · Node.js · AWS · CI/CD · OAuth2 · Security`
    ]
  },
  {
    role: "Solution Architect / Tech Lead (Contractor)",
    company: "Centrality.ai Ltd. / P^werFinance",
    companylogo: require("../assets/images/powerfinanceLogo.png"),
    date: "Aug 2020 – Aug 2021 (Auckland, New Zealand)",
    desc: `Led a team of 3 developers while remaining hands-on in architecture design and code reviews, overseeing DevOps collaboration and production delivery using TDD, BDD, CI/CD, and Agile methodologies. Interacted with stakeholders, product owners, and designers to ensure business requirements were accurately mapped to technical assets and skill sets. Architected and implemented a blockchain-based banking platform, including secure minting and burning of encrypted digital assets.`,
    descBullets: [
      `Skills & Technologies: Leadership · Blockchain · Cryptography · TypeScript · React · Node.js · Azure · TDD · BDD · CI/CD · Agile · Terraform · RESTful APIs`
    ]
  },
  {
    role: "Senior Fullstack Developer",
    company: "Propellerhead Ltd.",
    companylogo: require("../assets/images/phlLogo.png"),
    date: "Oct 2018 – Aug 2020 (Auckland, New Zealand)",
    desc: `Mentored junior developers and collaborated with stakeholders and designers to develop and maintain cloud-based mission control software for Auckland Transport, ensuring real-time data flow and fleet management. Reduced public transport messaging/rerouting process by 50% by implementing a Kafka- and Redis-based live GPS tracking solution with retry mechanisms, to automatically send messages to desired stations. Developed and maintained internal applications, including a badge framework for tracking career progression, a spending application, and a revenue forecasting tool.`,
    descBullets: [
      `Skills & Technologies: TypeScript · React · Node.js · Azure · Kafka · Redis · PostgreSQL · GraphQL · CI/CD · Docker · Cucumber · Cypress · Jest`
    ]
  },
  {
    role: "Senior IT Consultant (Contractor)",
    company: "INFOMOTION GmbH",
    companylogo: require("../assets/images/infomotionLogo.png"),
    date: "Jun 2018 – Oct 2018 (Frankfurt, Germany)",
    desc: `Automated data extraction from SAP reports by implementing the "Easy Cockpit" portal, which led to a more user-friendly data presentation for managers and saved time.`,
    descBullets: [
      `Skills & Technologies: SAP · Data extraction · Web portal · Angular · Git · RESTful APIs · SQL · Docker · Spring · JEE`
    ]
  },
  {
    role: "Senior IT Consultant",
    company: "OBJECT ECM GmbH",
    companylogo: require("../assets/images/objectECMLogo.png"),
    date: "Apr 2016 – Jun 2018 (Zurich, Switzerland)",
    desc: `Led a team of junior and intermediate developers, managing various projects and ensuring alignment with stakeholder requirements. Reduced construction application processing time by 50% by implementing an internal web portal and a workflow engine for the Thüringer Aufbaubank, which led to 50% higher state-based support for the citizens.`,
    descBullets: [
      `Skills & Technologies: Leadership · JavaScript · Java · HTML5 · CSS3 · Alfresco ECM · Activiti · RESTful · Spring · Hibernate · Git · Maven · Jenkins`
    ]
  },
  {
    role: "Fullstack Developer",
    company: "Sopra Steria GmbH",
    companylogo: require("../assets/images/sopraSteriaLogo.png"),
    date: "Feb 2014 – Apr 2016 (Hamburg, Germany)",
    desc: `Reduced credit fraud by 40% by implementing a web-based fraud prevention tool and rule-engine for banks and investment companies, in a team of 3 developers.`,
    descBullets: [
      `Technologies: JEE · JSF · Primefaces · jQuery · Java · HTML5 · CSS3 · JavaScript · Spring · Hibernate · jboss`
    ]
  },
  {
    role: "Web Developer",
    company: "NTT DATA Deutschland",
    companylogo: require("../assets/images/NTTDataLogo.png"),
    date: "Nov 2012 – Feb 2014 (Munich, Germany)",
    desc: `Optimized after-sales communication for BMW and Audi through implementation of integrated web applications, resulting in a 30% reduction in waiting times and operating costs.`,
    descBullets: [
      `Technologies: JavaScript · jQuery · Java J2EE · HTML · CSS · XSLT · JSP · JSF`
    ]
  }
];
